import React, { useEffect } from 'react';

const Banned: React.FC = () => {
  useEffect(() => {
    document.title = 'OfferFlow | Account Suspended';
  }, []);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f9fafb',
      fontFamily: 'inherit',
    }}>
      <div style={{
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: '16px',
        padding: '48px 40px',
        maxWidth: '420px',
        textAlign: 'center',
      }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🚫</div>
        <h1 style={{ fontSize: '22px', fontWeight: 700, color: '#1f2937', marginBottom: '12px' }}>
          Account Suspended
        </h1>
        <p style={{ fontSize: '14px', color: '#6b7280', lineHeight: 1.6 }}>
          Your account has been suspended. If you believe this is a mistake,
          please contact support at{' '}
          <a href="mailto:support@offerflow.pro" style={{ color: '#D85A3A' }}>
            support@offerflow.pro
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default Banned;
